import NavBar from "./presentation/components/NavBar.vue";
/**
 * Header Module - provides navigation bar component
 */
export class HeaderModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[HeaderModule] Registered");
        return {
            id: "header",
            name: "Header Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        // Header typically doesn't provide routes, return empty array
        return [];
    }
    getNavigationItems() {
        // Header typically doesn't provide navigation items, return empty array
        return [];
    }
    getComponent(slotName) {
        if (slotName === "header") {
            return NavBar;
        }
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[HeaderModule] Unregistered");
        this.contracts = null;
    }
}
// Export singleton instance
export default new HeaderModule();
